<template>
  <div class="animate-pulse">
    <div v-if="type === 'form'" class="space-y-6">
      <div class="h-8 bg-gray-200 rounded w-1/3"></div>
      <div class="space-y-4">
        <div class="h-4 bg-gray-200 rounded w-1/4"></div>
        <div class="h-10 bg-gray-200 rounded"></div>
      </div>
      <div class="space-y-4">
        <div class="h-4 bg-gray-200 rounded w-1/4"></div>
        <div class="h-10 bg-gray-200 rounded"></div>
      </div>
      <div class="space-y-4">
        <div class="h-4 bg-gray-200 rounded w-1/4"></div>
        <div class="h-10 bg-gray-200 rounded"></div>
      </div>
    </div>
    
    <div v-else-if="type === 'list'" class="space-y-4">
      <div class="h-6 bg-gray-200 rounded w-1/3"></div>
      <div v-for="n in 5" :key="n" class="flex items-center space-x-4 p-4 border rounded">
        <div class="h-12 w-12 bg-gray-200 rounded-full"></div>
        <div class="flex-1 space-y-2">
          <div class="h-4 bg-gray-200 rounded w-3/4"></div>
          <div class="h-3 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    </div>
    
    <div v-else class="space-y-4">
      <div class="h-8 bg-gray-200 rounded w-1/2"></div>
      <div class="h-4 bg-gray-200 rounded w-3/4"></div>
      <div class="h-4 bg-gray-200 rounded w-2/3"></div>
      <div class="h-4 bg-gray-200 rounded w-1/2"></div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'form', 'list'].includes(value)
  }
})
</script>